import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import 'core-js'
import Swiper from 'swiper/dist/js/swiper.js'
import 'swiper/dist/css/swiper.min.css'
import AOS from 'aos/dist/aos.js'
import 'aos/dist/aos.css'


(function ($) {
    $(document).ready(function () {
        AOS.init()

        var swiper = new Swiper('.valtcimsor-swiper-container', {
            effect: 'fade',
            autoplay: {
                delay: 2000,
                disableOnInteraction: true,
            },
        })

        $('.burger').click(function(e) {
            e.preventDefault()

            if ( $(this).hasClass('opened')) {
                $(this).removeClass('opened')
                $('#mobilenav').removeClass('opened')
                $('body').removeClass('menu_opened')
            } else {
                $(this).addClass('opened')
                $('#mobilenav').addClass('opened')
                $('body').addClass('menu_opened')
            }
        })
    })
})(jQuery)